<agr-dialog [data]="data" (cancel)="cancel()" class="product-search-dialog" data-test="product-search-dialog">
  <div class="product-search-dialog__form spacing--margin-top">
    <mat-form-field appearance="fill" class="product-search-dialog__input" data-test="product-search-dialog__input">
      <mat-label>{{ 'product.search.search-label' | translate }}</mat-label>
      <mat-icon matPrefix>search</mat-icon>
      <input
        #productSearch
        type="text"
        matInput
        [placeholder]="'product.search.select' | translate"
        [formControl]="productSearchControl"
        class="product-search-dialog__input-text"
        data-test="product-search-dialog__input-text"
        (keydown.enter)="$event.preventDefault()"
        autocomplete="on"
      />
      <button *ngIf="productSearchControl.value" matSuffix mat-icon-button (click)="resetProductSearch()">
        <mat-icon>close</mat-icon>
      </button>
    </mat-form-field>
  </div>

  <div class="product-search-dialog__table spacing--margin-bottom">
    <h4 class="spacing--margin-none-top">
      <ng-container [ngPlural]="tableConfig?.dataSource?.data?.length || 0">
        <ng-template ngPluralCase="=0"> 0 {{ 'product.search.found-products' | translate }} </ng-template>
        <ng-template ngPluralCase="=1"> 1 {{ 'product.search.found-product' | translate }} </ng-template>
        <ng-template ngPluralCase="other">
          {{ tableConfig.dataSource.data?.length || 0 }}
          {{ 'product.search.found-products' | translate }}
        </ng-template>
      </ng-container>
    </h4>

    <agr-table
      *ngIf="tableConfig?.dataSource?.data"
      [config]="tableConfig"
      [isEmpty]="(skuCatalogItemsLoaded$ | async) !== true || !tableConfig?.dataSource?.data?.length"
      [emptyTitle]="'product.search.table.' + ((skuCatalogItemsLoaded$ | async) !== true ? 'loading' : 'no-results') + '.title' | translate"
      [emptyDescription]=""
    ></agr-table>
  </div>
</agr-dialog>

<ng-template #productColumn let-row="row">
  <div
    class="flex--column flex--justify-center"
    [class]="row.isCatalogItemEligibleForCart ? 'product-search-dialog__product-column' : 'product-search-dialog__product-column--disabled'"
    (click)="openWizardDialog(row)"
    (keydown.enter)="openWizardDialog(row)"
  >
    <span class="text--default">{{ row.title }}</span>
    <span class="text--label">
      {{ 'product.search.table.article-number' | translate: { articleNumber: row.externalSkuId } }}
    </span>
  </div>
</ng-template>

<ng-template #addToCartColumn let-row="row">
  <div class="flex--row flex--align-end product-search-dialog__add-to-cart-wrapper">
    <button
      *ngIf="(breakpoint.xs$ | async) === false"
      mat-flat-button
      color="primary"
      class="text--small product-search-dialog__add-to-cart"
      data-test="product-search-dialog__add-to-cart"
      (click)="addToCart(row)"
      [disabled]="!orderQuantities?.length || orderQuantities.at(row.index).invalid || !row.isCatalogItemEligibleForCart"
    >
      <mat-icon *ngIf="row.isCatalogItemEligibleForCart" class="product-search-dialog__add-shopping-icon">add_shopping_cart</mat-icon>
      <span>{{
        row
          | formatAddProductToCartButtonText
            : {
                hasAtLeastAdvisorRole,
                cartType: data.cart?.type,
                useDefaultText: environment.ALLOWED_ORDER_ROLES_DISABLED,
              }
          | translate
      }}</span>
    </button>

    <button
      *ngIf="(breakpoint.xs$ | async) === true"
      mat-flat-button
      color="primary"
      class="text--small product-search-dialog__add-to-cart-mobile"
      data-test="product-search-dialog__add-to-cart"
      (click)="addToCart(row)"
      (keydown.enter)="addToCart(row)"
      [disabled]="!row.isCatalogItemEligibleForCart"
    >
      <mat-icon class="product-search-dialog__add-shopping-icon-mobile">add_shopping_cart</mat-icon>
    </button>
  </div>
</ng-template>

<ng-template #addToSiloColumn let-row="row">
  <div class="flex--row flex--align-end product-search-dialog__add-to-cart-wrapper">
    <button
      *ngIf="(breakpoint.xs$ | async) === false"
      mat-flat-button
      color="primary"
      class="text--small product-search-dialog__add-to-cart"
      data-test="product-search-dialog__add-to-silo"
      (click)="openWizardDialog(row)"
    >
      <mat-icon class="product-search-dialog__add-shopping-icon">add_task</mat-icon>
      <span>{{ 'product.add-to-silo' | translate }}</span>
    </button>

    <button
      *ngIf="(breakpoint.xs$ | async) === true"
      mat-flat-button
      color="primary"
      class="text--small product-search-dialog__add-to-cart-mobile"
      data-test="product-search-dialog__add-to-silo"
      (click)="openWizardDialog(row)"
      (keydown.enter)="openWizardDialog(row)"
    >
      <mat-icon class="product-search-dialog__add-shopping-icon-mobile">add_task</mat-icon>
    </button>
  </div>
</ng-template>

<ng-template #mobileColumn let-row="row">
  <div
    class="flex--column flex--justify-center"
    [class]="row.isCatalogItemEligibleForCart ? 'product-search-dialog__mobile-column' : 'product-search-dialog__mobile-column--disabled'"
    (click)="openWizardDialog(row)"
    (keydown.enter)="openWizardDialog(row)"
  >
    <span class="text--default">{{ row.title }}</span>
    <span class="flex--row flex--align-center text--label">
      {{ row.externalSkuId }}
    </span>
  </div>
</ng-template>

<ng-template #favoriteStarColumn let-row="row">
  <app-favorites-star class="favorite-star" [skuId]="row.skuId"></app-favorites-star>
</ng-template>
